module.exports = __webpack_public_path__ + "static/rt-patterson.0884e476.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/rt-patterson.gif
// module id = 715
// module chunks = 23899280101116